import type {
  PrizeLocatorCategoriesConfig,
  StoreLocatorFilter,
} from "@locators/components/PrizeLocator/PrizeLocator.types";

import type { FlotiqStorePrizeLocator } from "@jti/fe-common";

export const CATEGORY = "Categories" as keyof Pick<FlotiqStorePrizeLocator, "Categories">;

export const getFiltersBaseOnFlotiqResponse = (
  stores: FlotiqStorePrizeLocator[],
  filtersTranslations: PrizeLocatorCategoriesConfig[]
) => {
  const getCategoryConfig = (key: string) => {
    const categoryConfig = filtersTranslations.find(({ filterKey }) => filterKey === key);
    return {
      translatedName: categoryConfig?.translatedFilterKey || key,
      imageReference: categoryConfig?.image ?? "",
    };
  };

  return stores.reduce((acc: StoreLocatorFilter, store: FlotiqStorePrizeLocator) => {
    store[CATEGORY]?.forEach((item) => {
      const categoryConfig = getCategoryConfig(item.key);
      if (!acc.some((filter) => filter.categoryKey === item.key)) {
        acc.push({
          label: categoryConfig.translatedName,
          categoryKey: item.key,
          iconUrl: categoryConfig.imageReference,
        });
      }
    });
    return acc;
  }, []);
};
